/**
 * =================
 * Content Generated RWD BreakPoints
 * relies on css generated content
 * in order to decouple breakpoint definition from JS
 * tool
 * =================
 */
app.cgBreakpoints = (function() {

	// staff
	var win = window,
	    doc = win.document,
	    el,
	    bkpClass;

	var module = {
		currBkp: '',
		getBkp: function() {
			el = el || doc.body;

			if (el && win.getComputedStyle) {
				return win.getComputedStyle(el, ':before')
          .getPropertyValue('content')
          .replace(/["']/g, '');
			}
		},
		applyBkp: function() {
			var currBkp = module.getBkp();

			if (!el) return false;

			el.className = el.className.replace(bkpClass, '').replace(/^\s+|\s+$/g, '');

			if (currBkp && currBkp !== 'none') {
				el.className = currBkp + " " + el.className;

				if (currBkp !== bkpClass) {
					app.$(el).trigger('onBreakpointChange', [currBkp]);
				}

				bkpClass = currBkp;
				module.currBkp = currBkp;
			}
		},
		listening: false,
		listen: function(wait, immediate) {
			var _self = this;

			this.flush();

			var handler = wait == 0 && _self.applyBkp || _.debounce(_self.applyBkp, wait || 250, immediate);

			this.applyBkp();
			window.addEventListener && window.addEventListener('resize', handler);
			this.listening = true;

			return this.resizeHandler = handler;
		},
		flush: function() {
			this.listening = false;

			var handler = this.resizeHandler;

			if (handler && typeof handler === 'function') {
				window.removeEventListener && window.removeEventListener('resize', handler);
				handler = this.resizeHandler = null;
			}
		}
	};

	module.onBreakpointChange = function(listener) {
		if (listener && typeof listener === 'function') {
			el && app.$(el).on('onBreakpointChange', listener);
		}

		return this;
	};

	// kickstart! if not yet listening (inits...)
	// poll for html (faster) or body ASAP
	(function poll() {
		if (module.listening) return;

		el = document.documentElement || doc.body;

		if (el) {
			module.listen(0, false);
			return;
		}

		window.setTimeout(poll, 13);
	}());

	return module;

}());


/**
 * =================
 * Box read more
 * =================
 */
app.boxTextMore = (function(module){

	// staff
	var bkpClass;

	// init
	module.init = function($els){

		var $root = app.$('[id="box-text-more"]'),
				showChar = 374,
				content = $root.children('p:first-child').html();

		var c = content.substr(0, showChar);
		var h = content.substr(showChar-1, content.length - showChar);

		$root.children('p:first-child').html(c + '<span class="moreellipses">...</span> <span class="morecontent">' + h + '</span>');

		$root.find("p > .lnk").click(function(){
				$root.children('p:first-child').html(content);
				$root.children('p:last-child').toggle();
				return false;
		});

	};

	return module;

}(app.boxTextMore || {}));


/**
 * =================
 * course suscription form
 * =================
 */
app.btnCourseSuscr = (function(module){

	// init
	module.init = function($els){

		var $btn = app.$('.btn-course-suscr'),
				$ly1 = app.$('#boxCourseSuscr'),
				$ly2 = app.$('#boxCourseSuscr2');

		$btn.click(function(){
				$btn.toggle();
				$ly1.toggle();
				$ly2.toggle();
				return false;
		});

	};

	return module;

}(app.btnCourseSuscr || {}));



/* =================
 * BACK TO TOP LINK
 * =================
 */
app.backToTop = (function(module){

	var $win = app.$(window);

	// settings

	// browser window scroll (in pixels) after which the "back to top" link is shown
	var offset = 300,
	 // browser window scroll (in pixels) after which the "back to top" link opacity is reduced
		offset_opacity = 1200,
	 // duration of the top scrolling animation (in ms)
		scroll_top_duration = 700;

	// main init
	module.init = function() {
		var $link = app.$("#backtoTop");

		$win.on("scroll", function(e){
			if ($win.scrollTop() > offset) {
				$link.addClass("visible");
			} else {
				$link.removeClass("visible fade-out");
			}
			if ($win.scrollTop() > offset_opacity) { $link.addClass("fade-out"); }
		});

		$link.on("click", function(e){
			e.preventDefault();
			app.$("html, body").animate({scrollTop: 0}, scroll_top_duration);
		});

		return $link;
	};


	// kickstart!
	app.$(function(){
		module.init();
	});

	return module;

})(app.backToTop || {});


/* =================
 * TELINPUT VALIDATION
 * =================
 */
// app.telInputValidate = (function(module) {
//
// 	var errorTxt = 'Debe introducir un número de teléfono válido';
//
// 	// init
// 	module.init = function($els){
// 		var $input = app.$("input[type='tel']");
//
// 		// on blur: validate
// 		$input.on("blur", function() {
// 			if (app.$.trim(app.$(this).val())) {
// 				var container = app.$(this).closest('.intl-tel-input');
// 				var parent = container.parent('.form-tel');
// 				if (app.$(this).intlTelInput("isValidNumber")) {
// 					parent.removeClass('error');
// 					if (container.prev().length > 0 && container.prev().hasClass('errors')) {
// 						container.prev().hide();
// 					}
// 				} else {
// 					parent.addClass('error');
// 					if (container.prev().length > 0 && container.prev().hasClass('errors')) {
// 						container.prev().html('<p>' + errorTxt + '</p>');
// 						container.prev().show();
// 					} else {
// 						container.before('<div class="errors"><p>' + errorTxt + '</p></div>');
// 					}
// 				}
// 			}
// 		});
//
// 		// on keyup / change flag: reset
// 		$input.on("keyup change", function(){
// 			var container = app.$(this).closest('.intl-tel-input');
// 			var parent = container.parent('.form-tel');
// 			parent.removeClass('error');
// 			if (container.prev().length > 0 && container.prev().hasClass('errors')) {
// 				container.prev().hide();
// 			}
// 		});
// 	};
//
// 	return module;
//
// })(app.telInputValidate || {});


/* EOF */
